import api from "../../../api";
import { createAppAsyncThunk } from "../../../redux/hooks";

const fetchMyChatrooms = createAppAsyncThunk('chat/fetchMyChatrooms', async () => {
  return api.chat.myChatrooms();
});

export default fetchMyChatrooms;